import HeroFeatures from './features/HeroFeatures';
import Header from './Header';
import MobileNavigation from './MobileNavigation';
import frontImg from './img/softwareIntegrations.svg';
import epicLogo from './img/epicLogo.png';
import Footer from './Footer';
import background from './img/softwarePartners.png';
import handGears from './img/icon-hands-gears.svg';
import { Link } from 'react-router-dom';
import { useRef } from 'react';
import { useGSAP } from '@gsap/react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import quickbooksLogo from './img/quickbooksWhite.png';
import quickbooksLogoDark from './img/quickbooks.png';
import wooCommerce from './img/woocommerce.png';
import wooCommerceDark from './img/woocommerce-dark.png';

gsap.registerPlugin(useGSAP);
gsap.registerPlugin(ScrollTrigger);

export default function Integrations() {
  const container = useRef();
  useGSAP(
    () => {
      gsap.fromTo(
        '.hero-left',
        { opacity: 0, y: 100 },
        { opacity: 1, y: 0, duration: 1, ease: 'power2.inOut' }
      );
      gsap.fromTo(
        '.cols-span-2',
        { opacity: 0, y: 100 },
        { opacity: 1, y: 0, duration: 1, ease: 'power2.inOut' }
      );
      let cards = gsap.utils.toArray('.card');
      gsap.from(cards, {
        duration: 1,
        opacity: 0,
        y: 50,
        stagger: 0.1,
        ease: 'power3.inOut',
        scrollTrigger: {
          trigger: '.card',
          start: 'top bottom-=200',
          end: 'top bottom+=100'
        }
      });
      let cards2 = gsap.utils.toArray('.card2');
      gsap.from(cards2, {
        duration: 1,
        opacity: 0,
        y: 50,
        stagger: 0.1,
        ease: 'power3.inOut',
        scrollTrigger: {
          trigger: '.card2',
          start: 'top bottom-=200',
          end: 'top bottom+=100'
        }
      });
      gsap.from('.epic', {
        duration: 1,
        opacity: 0,
        y: 50,
        stagger: 0.1,
        ease: 'power3.inOut',
        scrollTrigger: {
          trigger: '.epic',
          start: 'top bottom-=200',
          end: 'top bottom+=100'
        }
      });
      const how = document.querySelector('.how').children;
      gsap.fromTo(
        how,
        { opacity: 0, y: 100 },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          ease: 'power2.in',
          stagger: 0.1,
          scrollTrigger: { trigger: '.how', start: 'top bottom-=200', end: 'top bottom+=100' }
        }
      );
      gsap.fromTo(
        '.security',
        { opacity: 0, y: 100 },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          ease: 'power2.in',
          stagger: 0.1,
          scrollTrigger: { trigger: '.security', start: 'top bottom-=200', end: 'top bottom+=100' }
        }
      );
      gsap.fromTo(
        '.future',
        { opacity: 0, y: 100 },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          ease: 'power2.in',
          stagger: 0.1,
          scrollTrigger: { trigger: '.future', start: 'top bottom-=200', end: 'top bottom+=100' }
        }
      );
      gsap.fromTo(
        '.getStarted',
        { opacity: 0, y: 100 },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          ease: 'power2.in',
          stagger: 0.1,
          scrollTrigger: {
            trigger: '.getStarted',
            start: 'top bottom-=100',
            end: 'top bottom+=100'
          }
        }
      );
      gsap.fromTo(
        '.streamlined',
        { opacity: 0, y: 100 },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          ease: 'power2.in',
          stagger: 0.1,
          scrollTrigger: {
            trigger: '.streamlined',
            start: 'top bottom-=200',
            end: 'top bottom+=100'
          }
        }
      );
    },
    { context: container }
  );
  return (
    <>
      <main ref={container}>
        <Header />
        <MobileNavigation />
        <HeroFeatures
          title="SOFTWARE INTEGRATIONS"
          primary="Seamless Integration Solutions."
          secondary="No more compromising your work to adapt to your payment software."
          img={frontImg}
          imgAlt="vectors"
        />
        <section className="">
          <div className="grid grid-cols-1 gap-4 row sm:grid-cols-2">
            <article className="card">
              <h2 className="has-icon integrations">A dependable payment partnership</h2>
              <p className="light">Secure, compliant, and efficient infrastructure.</p>
            </article>
            <article className="card">
              <h2 className="has-icon puzzle">Support that meets your needs</h2>
              <p className="light">
                Customized support during development and implementation assistance.
              </p>
            </article>
            <article className="card">
              <h2 className="has-icon ribbon">The Basys best</h2>
              <p className="light">
                Better is Better. Worldclass service for lifetime of relationship.
              </p>
            </article>
            <article className="card">
              <h2 className="has-icon documentation">Resources</h2>
              <p className="light">Scalable APIs and SDKs.</p>
            </article>
          </div>
        </section>
        <section>
          <div className="grid items-start self-stretch grid-cols-1 gap-16 lg:grid-cols-3 row">
            <section className="flex flex-col items-start justify-center gap-6 card2">
              <h2 className="self-stretch text-center">
                <Link to="/integrations-e-commerce" className="underline">
                  <b>
                    <i>E-commerce</i>
                  </b>
                </Link>
              </h2>
              <p className="text-center light">
                E-commerce payment processing that’s tailored to and evolves alongside your software
                needs.
              </p>
            </section>
            <section className="flex flex-col items-start justify-center gap-6 card2">
              <h2 className="self-stretch text-center">
                <b>
                  <i>Accounting</i>
                </b>
              </h2>
              <p className="text-center light">
                Streamline your billing and invoicing processes with our flexible payment
                integrations.
              </p>
            </section>
            <section className="flex flex-col items-start justify-center gap-6 card2">
              <h2 className="self-stretch text-center">
                <b>
                  <i>ERP</i>
                </b>
              </h2>
              <p className="text-center light">
                Power up with the perfect solution and access highly competitive revenue sharing
                agreements.
              </p>
            </section>
          </div>
        </section>

        <section className="">
          <div
            className="row"
            style={{
              borderRadius: '25px',
              backgroundImage: `url(${background})`,
              backgroundSize: '200% 200%',
              backgroundPosition: 'bottom center',
              backgroundRepeat: 'no-repeat'
            }}
          >
            <div className="p-4 mx-auto md:p-8 how">
              <h3 className="text-white large">
                Need a custom solution or help finding the right fit for your business needs?
              </h3>
              <p className="text-white light">
                Your customers have unique needs. As your business partner, Basys works individually
                with every customer to find the right solution(s) for their business, including:
              </p>
              <ul className="my-8 fancy-bullets white">
                <li>
                  <p className="text-white light">Automated recurring billing.</p>
                </li>
                <li>
                  <p className="text-white light">Click-to-pay link for email invoicing.</p>
                </li>
                <li>
                  <p className="text-white light">ACH processing/Check processing.</p>
                </li>
                <li>
                  <p className="text-white light">
                    Quick online access to transaction history and reports.
                  </p>
                </li>
                <li>
                  <p className="text-white light">Easy to read merchant statements.</p>
                </li>
              </ul>
            </div>
          </div>
        </section>
        <section className="flex flex-wrap justify-center row gap-x-12 gap-y-16 my-20">
          <div className="flex flex-col items-center w-[360px] max-w-full gap-6 epic">
            <img src={epicLogo} alt="Epic logo" className="w-full h-20 object-contain" />
            <h2>
              <Link to="/integrations-epic" className="underline">
                Learn More
              </Link>
            </h2>
          </div>
          <div className="flex flex-col items-center w-[360px] max-w-full gap-6 epic">
            <img
              src={quickbooksLogo}
              alt="QuickBooks logo"
              className="hidden dark:block w-full h-20 object-contain"
            />
            <img
              src={quickbooksLogoDark}
              alt="QuickBooks logo"
              className="dark:hidden w-full h-20 object-contain"
            />
            <h2>
              <a
                href="https://basyspro.com/quickbooks/"
                target="_blank"
                rel="noreferrer"
                className="underline"
              >
                Learn More
              </a>
            </h2>
          </div>
          <div className="flex flex-col items-center w-[360px] max-w-full gap-6 epic">
            <img
              src={wooCommerceDark}
              alt="WooCommerce logo"
              className="hidden dark:block w-full h-20 object-contain"
            />
            <img
              src={wooCommerce}
              alt="WooCommerce logo"
              className="dark:hidden w-full h-20 object-contain"
            />
            <h2>
              <Link to="/integrations-woo-commerce" className="underline">
                Learn More
              </Link>
            </h2>
          </div>
        </section>
        <section className="">
          <div className="flex flex-col gap-6 row security">
            <p className="large">Powerful tools for developers.</p>
            <div className="flex max-[639px]:flex-col items-start justify-center gap-6">
              <div className="flex flex-col items-start gap-2 self-stretch w-[46%] max-[639px]:w-full">
                <p className="light max-[639px]:self-center">
                  Our payment API documentation also helps your clients do business from one
                  convenient central hub—your software. That means automation, reporting, customer
                  management and payments.
                </p>
                <div className="flex flex-col gap-2">
                  <p className="mb-0 light">
                    <i>Comprehensive API documentation</i>
                  </p>
                  <p className="mb-0 light">
                    <i>Postman collections to help jump start development</i>
                  </p>
                  <p className="mb-0 light">
                    <i>Sandbox environment</i>
                  </p>
                  <p className="mb-0 light">
                    <i>API playground</i>
                  </p>
                </div>
                <a
                  href="https://api.basyspro.com/iqsaas/v1/scalar/"
                  target="_blank"
                  rel="noreferrer"
                  className="button button-primary has-arrow has-arrow-white"
                >
                  View Developer Docs
                </a>
              </div>

              <div className="w-[1px] h-80 bg-[#D9D9D9] max-[840px]:hidden"></div>
              <div
                className="flex flex-col items-start self-stretch justify-center gap-6"
                style={{ flex: '1 0 0' }}
              >
                <Link
                  to="/developer-physical-terminals"
                  style={{ maxWidth: '100%', background: 'none' }}
                  className="w-full button button-secondary dark:button-primary has-arrow dark:has-arrow-white border-2 border-[#4452A3]"
                >
                  Physical Terminals
                </Link>
                <Link
                  to="/developer-tokenization"
                  style={{ maxWidth: '100%', background: 'none' }}
                  className="w-full button button-secondary dark:button-primary has-arrow dark:has-arrow-white border-2 border-[#4452A3]"
                >
                  Tokenization
                </Link>
                <Link
                  to="/developer-test-data"
                  style={{ maxWidth: '100%', background: 'none' }}
                  className="w-full button button-secondary dark:button-primary has-arrow dark:has-arrow-white border-2 border-[#4452A3]"
                >
                  Test Data
                </Link>
                <Link
                  to="/release-notes"
                  style={{ maxWidth: '100%', background: 'none' }}
                  className="w-full button button-secondary dark:button-primary has-arrow dark:has-arrow-white border-2 border-[#4452A3]"
                >
                  Release Notes
                </Link>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="flex row future">
            <section className="flex max-[639px]:flex-col max-[639px]:self-center gap-10 my-8 callout p-14">
              <img
                className="m-0 max-[639px]:scale-75 self-center"
                src={handGears}
                alt="hand holding gears"
              />
              <div
                className="flex flex-col items-start justify-center gap-6"
                style={{ flex: '1 0 0' }}
              >
                <h2 className="text-left">We’re with you every step.</h2>
                <p className="text-left light">
                  The Basys Integration team provides comprehensive integration support for software
                  providers. Our customizable API gateways meet the needs of your software, not the
                  other way around—and as your products evolve, ours will too.
                </p>
                <div className="grid w-full grid-cols-1 sm:grid-cols-2">
                  <div className="flex flex-col items-start">
                    <p className="font-semibold text-left">
                      <i>Dedicated integration specialists</i>
                    </p>
                    <p className="font-semibold text-left">
                      <i>Onboarding support</i>
                    </p>
                  </div>
                  <div className="flex flex-col items-start">
                    <p className="font-semibold text-left">
                      <i>24/7 general support</i>
                    </p>
                    <p className="font-semibold text-left">
                      <i>Extensive knowledge base</i>
                    </p>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </section>
        <section className="">
          <div className="row streamlined">
            <div className="grid justify-center grid-cols-1">
              <p className="max-[639px]:text-center large">Secure by design.</p>
            </div>
            <div className="grid grid-cols-1 pb-8">
              <p className="max-[639px]:text-center light">
                We know how important data security is for payment integration, and we take
                protective measures seriously. Your customers are as important to us as they are to
                you, and we’ll treat them with the same care and attention that your organization
                does. We accomplish this by offering equipment, products and programs to manage
                payments seamlessly.  
              </p>
            </div>
            <div className="flex max-[639px]:flex-col items-center self-stretch justify-center gap-8">
              <p className="text-center medium">
                <i>PCI-DSS level 1 compliant</i>
              </p>
              <div className="w-[250px] h-[1px] bg-[#D9D9D9] max-[639px]:hidden"></div>
              <p className="text-center medium">
                <i>Tokenization & Encryption</i>
              </p>
              <div className="w-[250px] h-[1px] bg-[#D9D9D9] max-[639px]:hidden"></div>
              <p className="text-center medium">
                <i>Regular security audits</i>
              </p>
            </div>
          </div>
        </section>
        <section className="getStarted">
          <div className="grid items-center justify-center grid-cols-1 row row-sm">
            <div>
              <p className="text-center large">Ready to integrate with Basys?</p>
              <Link
                to="/bookDemo"
                className="button button-primary center has-arrow has-arrow-white"
              >
                Book a demo today!
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
